import * as Yup from "yup";
const migrationConfigSchema = Yup.object({
    from_company_region: Yup.string().required("Source Company Environment is required"),
    to_company_region: Yup.string().required("Destination Company Environment is required"),
    from_company_name: Yup.string().required("Source Company Login Name is required"),
    to_company_name: Yup.string().required("Destination Company Login Name is required"),
    from_api_key: Yup.string().required("Source Company API Key is required"),
    to_api_key: Yup.string().required("Destination Company API Key is required"),
    cloneAccount: Yup.string().optional(),
});

const validationSchema = {
     migrationConfigSchema
};
export default validationSchema;
